.page {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-8x);
    max-width: 70.5rem;
    margin: 0 auto;
    padding: var(--bi-scale-8x) var(--bi-scale-8x) var(--bi-scale-16x);

    @media (width < 768px) {
        padding-inline: var(--bi-scale-4x);
    }
}

.filterButton {
    align-self: flex-start;
}

.filterDrawer {
    width: 100%;

    .filterActionButton {
        flex: 1;
    }
}

.list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    @media (width < 768px) {
        grid-template-columns: 1fr;
        row-gap: var(--bi-scale-6x);
    }
}
